import ProductTypeChip from '../../../components/ProductTypeChip'
import { renderProductNameWithMeta } from '../../exceptions/shared/productRenderers'
import type { ExceptionConfig } from '../../exceptions/types'
import { fmtInt, fmtMoney } from './formatters'
import type { InactiveInUseRow } from './types'

export const inactiveConfig: ExceptionConfig = {
  codes: [],
  complexity: 'comparison',
  rowKeyField: 'ls_id',
  defaultSortColumn: 'units_sold',
  defaultSortDirection: 'desc',
  clientDefaultPageSize: 100,
  columns: [
    {
      key: 'name',
      label: 'Product',
      align: 'left',
      render: renderProductNameWithMeta,
    },
    {
      key: 'product_type',
      label: 'Type',
      align: 'center',
      render: (_v, row) => (
        <ProductTypeChip productType={(row as InactiveInUseRow).product_type} dense />
      ),
    },
    {
      key: 'units_sold',
      label: 'Units sold',
      align: 'right',
      render: (v) => fmtInt(v as number),
    },
    {
      key: 'revenue',
      label: 'Revenue',
      align: 'right',
      render: (v) => fmtMoney(v as number),
    },
    {
      key: 'on_hand_units',
      label: 'On hand',
      align: 'right',
      render: (v) => fmtInt(v as number),
    },
    {
      key: 'on_hand_value',
      label: 'On hand value',
      align: 'right',
      render: (v) => fmtMoney(v as number),
    },
    {
      key: 'last_sale_date_local',
      label: 'Last sold',
      render: (v) => (v as string) || '-',
    },
  ],
}
